import styled from 'styled-components';

export const FooterStyles = styled.div`
  position: relative;
  margin-top: 10px;
  width: 100%;
  text-align: left;

  .source {
    font-size: 13px;
    line-height: 1.4;
  }
`;
